module.exports = __webpack_public_path__ + "img/rental-income.5529cb91.png";